const getters = {
    SmContractsPurchaseSales: state => state.sm_contracts_purchase_sales,
    smContractsPurchaseSaleTypes: state => state.sm_contracts_purchase_sale_types,
}

export default getters;
